
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "LOREM, IPSUM DOLOR",
    },
    name: {
      type: String,
      default: "",
    },
    slogan: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
    backgroundImage: {
      type: String,
      default: null,
    },
  },
});
